<template>
  <a-modal
    v-model="isShow"
    :closable="false"
    :mask-closable="false"
    :keyboard="false"
    :title="modalTit"
    :z-index="10000"
    :footer="null"
  >
    <a-form
      :form="form"
      @submit.prevent="loginHandle"
    >
      <a-form-item :label="pwdTitTxt">
        <a-input
          v-decorator="decorators.mixPassword"
          type="password"
        />
      </a-form-item>
      <a-form-item>
        <a-button
          html-type="submit"
          type="primary"
          :disabled="submitting"
          :loading="submitting"
        >
          {{ $t('message["204"]') }}
        </a-button>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { mixDequeue } from '@/lib/login-callbacks'
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
export default {
  name: 'AccountLogin',
  data () {
    return {}
  },
  computed: {
    ...mapState('mix', ['visible', 'decorators', 'submitting']),
    ...mapGetters('mix', ['userid']),
    isShow: {
      set (val) {
        val ? this.show() : this.hide()
      },
      get () {
        return this.visible
      }
    },
    pwdTitTxt () {
      return this.$t('message["632"]')
    },
    modalTit () {
      return this.$t('message["739"]')
    }
  },
  beforeCreate () {
    this.form = this.$form.createForm(this)
  },
  methods: {
    ...mapMutations('mix', ['show', 'hide']),
    ...mapActions('mix', ['loginChain']),
    loginHandle () {
      const { userid } = this
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          const chain = await this.loginChain()
          chain.params({
            ...values,
            userid
          })
            .setForm(this.form)
            .onSuccess(async () => {
              await mixDequeue()
              this.isShow = false
            })
            .fetch()
        }
      })
    }
  }
}
</script>
